$(document).ready(function() {

	var products_slider = new Swiper ('.products-slider', {
		slidesPerView: 1,
		loop: true,
		simulateTouch: true,
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 15,
		navigation: {
			nextEl: '.products-slider .next',
			prevEl: '.products-slider .prev',
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 1,
				spaceBetween: 35,
			},
			993: {
				slidesPerView: 2,
				spaceBetween: 35,
			},
			1201: {
				slidesPerView: 3,
				spaceBetween: 35,
			}
		}
	});

	var blog_slider = new Swiper ('.blog-slider', {
		slidesPerView: 1,
		loop: true,
		centeredSlides: true,
		simulateTouch: true,
		allowTouchMove: true,
		effect: 'slide',
		autoHeight: true,
		calculateHeight: true,
		spaceBetween: 15,
		pagination: {
			el: '.blog-slider .swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			576: {
				spaceBetween: 20,
				slidesPerView: 2,
                centeredSlides: true,
                loop: true,
			},
			1201: {
				spaceBetween: 30,
				slidesPerView: 3,
                centeredSlides: false,
                loop: false,
			}
		}
	});

});